import * as React from "react"

import { cn } from "@/lib/utils"

// Sprint 41 — Professional Teal cascade. 1px outline-variant border,
// rounded corners, teal focus halo via --ring. Matches the <Input>
// primitive's treatment so multi-line inputs feel cohesive with
// single-line ones.
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-outline-variant bg-card px-3 py-2 text-sm font-public-sans transition-colors",
        "placeholder:text-placeholder",
        "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
